import React from 'react';
import { Container, NavDropdown, Nav, Navbar, Form, FormControl, Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"
const Header = () => {

  return (
    <header className='websiteheaderonly'>


      <Container>
        <Navbar bg="light" expand="lg" className="websitenavbar">
          <Container fluid>
            <Navbar.Brand ><Nav.Link as={Link} to="/" eventKey="8" activeClassName="is-active" className="" >  <img className="headerlogo" src="images/logo.png" /></Nav.Link></Navbar.Brand>


            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav
                className="me-auto my-2 my-lg-0 nav justify-content-center"
                // style={{ maxHeight: '100px' }}
                navbarScroll
              >


                <Nav.Link as={Link} to="/about" eventKey="1" activeClassName="is-active" className="navmenu hmfirstmenu" >About Us</Nav.Link>

                {/* <Nav.Link as={Link} to="/about" eventKey="2" activeClassName="is-active"  className="hmothermenu2">About Us</Nav.Link> */}

                <Nav.Link className="hmothermenu2" as={Link} to="/homes" to="/homes" eventKey="3" activeClassName="is-active" >Homes</Nav.Link>

                <Nav.Link className="hmothermenu2" as={Link} to="/apartments" eventKey="4" activeClassName="is-active" >Serviced Apartments</Nav.Link>
                <Nav.Link className="hmothermenu2" as={Link} to="/blog" eventKey="5" activeClassName="is-active" >Blog</Nav.Link>
                <Nav.Link className="hmothermenu2 formobileonly" href="#" eventKey="8" ><button className="hmfirstboxbutton">Book your stay</button></Nav.Link>

              </Nav>


              <div className="d-flex headerseachform">
                {/* <Nav.Link className="hmothermenu2 fordesktoponly"  href=/"/apartments"><button className="hmfirstboxbutton2">Login</button></Nav.Link> */}
                <Nav.Link className="hmothermenu2 fordesktoponly" href="#" eventKey="8" ><button className="hmfirstboxbutton">Book your stay</button></Nav.Link>
              </div>
            </Navbar.Collapse>


          </Container>
        </Navbar>
      </Container>




    </header>
  )

};


export default Header;